import { styled } from '@mui/material';

export const PageDescription = styled('p')({
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "122%",
    textAlign: "center",
    color: "rgba(17, 25, 42, 0.69)",
    margin: 0,
    maxWidth: "600px",
    marginTop: "6px"
});
